<app-header></app-header>

<div class="mb-[30vh]">
  <div class="mr-10 ml-10 mt-10">
    <stdout-card>
      <stdout-card-header class="card-header">{{
        "crea notifica" | transloco
        }}</stdout-card-header>

      <stdout-card-content>
        <div class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 lg:grid-cols-4 xl:grid-cols-4">
          <div class="md:mr-[25px] mr-0">
            <div class="rounded-md w-full">
              <div class="mb-[10px] mt-1">
                <label class="primalabel" for="1"><b style="color: #0b0e42">{{
                    "titolo" | transloco
                    }}</b></label>
              </div>
              <stdout-text-input class="bordo" id="1" placeholder="Inserisci titolo" type="text"
                [(ngModel)]="title"></stdout-text-input>
            </div>
          </div>
          <div class="col-span-2 md:mt-1 mt-[10px]">
            <div class="rounded-md w-full">
              <div class="mb-[10px]">
                <label for="2" class="secondalabel">
                  <p>
                    <b style="color: #0b0e42">{{
                      "descrizione" | transloco
                      }}</b>
                  </p>
                </label>
              </div>
              <stdout-text-input class="bordo" id="2" placeholder="Inserisci descrizione" [(ngModel)]="description"
                type="text"></stdout-text-input>
            </div>
          </div>
          <div class="md:mt-1 mt-[10px] ml-0 md:ml-[25px]">
            <div class="mb-[10px]">
              <label class="terzalabel" for="1"><b style="color: #0b0e42">{{ "link" | transloco }}</b></label>
            </div>
            <stdout-text-input class="bordo" id="3" placeholder="Inserisci Link" [(ngModel)]="link"
              type="text"></stdout-text-input>
          </div>
          <div class="md:mr-[25px] mr-0 md:mt-1 mt-[10px] col-span-2 md:w-auto">
          <div class="rounded-md w-full">
            <div class="mb-[10px] mt-1">
              <label class="primalabel" for="1"><b style="color: #0b0e42">Programma</b></label>
            </div>
            <stdout-text-input class="bordo" id="1" placeholder="Inserisci per programmare" type="datetime-local"
              [(ngModel)]="customDate"></stdout-text-input>
          </div>
        </div>
        </div>

        <div class="flex flex-wrap md:flex-row flex-col">
          <div class="mt-[30px]">
            <div class="flex flex-wrap not">
              <label>
                <p [ngClass]="{'testo-errore': notificaErr }">{{ "dest_not" | transloco }}</p>
              </label>
            </div>
          </div>
          <div class="mt-[25px] ml-[25px]">
            <div class="flex flex-wrap fix-check-not items-center">
              <stdout-checkbox (change)="updateDestination(1, $event)" class="mr-2  cursor-pointer"
                #checkbox1></stdout-checkbox>

              <label>
                <p>{{ "tutti" | transloco }}</p>
              </label>
            </div>
          </div>
          <div class="mt-[25px] ml-[25px]">
            <div class="flex flex-wrap fix-check-not items-center">
              <stdout-checkbox (change)="updateDestination(2, $event)" class="mr-2  cursor-pointer"
                #checkbox2></stdout-checkbox>
              <label>
                <p>{{ "solo_mil" | transloco }}</p>
              </label>
            </div>
          </div>
          <div class="mt-[25px] ml-[25px]">
            <div class="flex flex-wrap fix-check-not items-center">
              <stdout-checkbox (change)="updateDestination(3, $event)" class="mr-2  cursor-pointer"
                #checkbox3></stdout-checkbox>
              <label>
                <p>{{ "solo_pub" | transloco }}</p>
              </label>
            </div>
          </div>
          <div class="w-[100%] mr-[25px]" style="text-align: -webkit-right">
            <div class="md:w-[200px]  cursor-pointer w-full margine">
              <stdout-button class="btn-blu" size="large" color="white" (click)="createNotification()">
                <p>{{ "crea_nuova" | transloco }}</p>
              </stdout-button>
            </div>
          </div>
        </div>
      </stdout-card-content>
    </stdout-card>
  </div>

  <hr />
  <div class="flex justify-between items-center mt-10 px-10">
    <div class="flex input-container" *ngIf="!isPhone">
      <stdout-icon-button class="lente" style="margin: 2px 10px 0px 0px" size="small" background="secondary"
        color="white" borderColor="secondary" [icon]="faMagnifyingGlass">
      </stdout-icon-button>
      <div class="md:w-[300px]">
        <stdout-text-input class="search-bar" placeholder="Cerca..." [(ngModel)]="search"
          (keyup)="applyFilter()"></stdout-text-input>
      </div>
    </div>
    <div class="posi">
      <div class="mr-[15px]">
        <p>Filtri</p>
      </div>

      <stdout-icon-button class="lente  cursor-pointer" [icon]="faCalendarDays"
        (click)="visibile($event)"></stdout-icon-button>

      <div *ngIf="showDropdown" class="dropdown ml-auto flex flex-col justify-center items-center px-5"
        (click)="$event.stopPropagation()">
        <div class="w-full data-text">
          <h1 class="mb-[10px]">Data</h1>
          <stdout-text-input class="date" type="date" (input)="handleDateSelection($event)" [(ngModel)]="date"
            (keyup)="applyFilter()"></stdout-text-input>
        </div>
        <div class="flex justify-between mt-10 w-full">
          <div class="mr-[10px] md:w-[120px]  cursor-pointer">
            <stdout-button (click)="date=null;applyFilter()" class="btn-bianco" size="large" color="black">
              <h2>{{ "resetta" | transloco }}</h2>
            </stdout-button>
          </div>
          <div class="md:w-[120px]  cursor-pointer">
            <stdout-button class="btn-blu" size="large" color="white" (click)="applyFilter()">
              <h2>{{ "applica" | transloco }}</h2>
            </stdout-button>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="mt-[10px] px-10 w-full select-none">
    <app-tabella2 [data]="notifications" [dataView]="notifications" [columns]="columns" [showCheck]='false'
      (itemCliccato)="showModalTable($event)" [isScrollable]="false" [changeId]="[]" [perTe]="[]">
    </app-tabella2>
  </div>

  <div class="mt-10 flex justify-center" *ngIf="notifications.length > 0">
    <stdout-pagination [current]="page" [total]="totalPages" (goTo)="getPage($event)" (next)="goNext($event)"
      (previous)="goBack($event)"></stdout-pagination>
  </div>
</div>

<div class="absolute top-[5%] w-[88.489%] flex justify-center items-center">
  <div class="w-fit h-full min-w-[500px]">
    <app-toast colore="#DF4343" [testo]="messErr" [showToast]="failToast"></app-toast>
  </div>
</div>
<div class="overlay fixed flex items-center justify-center top-0 left-0 w-full h-full z-[2000] bg-black/40"
  *ngIf="showModalEdit">
  <stdout-card>
    <stdout-card-content>
      <div class="text-[#0b0e42] font-semibold text-[18px] text-center">{{
        "modifica" | transloco
        }}</div>
      <div class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 lg:grid-cols-4 xl:grid-cols-4">
        <div class="md:mr-[25px] mr-0">
          <div class="rounded-md w-full">
            <div class="mb-[10px] mt-1">
              <label class="primalabel" for="1"><b style="color: #0b0e42">{{
                  "titolo" | transloco
                  }}</b></label>
            </div>
            <stdout-text-input class="bordo" id="1" placeholder="Inserisci titolo" type="text"
              [(ngModel)]="titleEdit"></stdout-text-input>
          </div>
        </div>
        <div class="col-span-2 md:mt-1 mt-[10px]">
          <div class="rounded-md w-full">
            <div class="mb-[10px]">
              <label for="2" class="secondalabel">
                <p>
                  <b style="color: #0b0e42">{{
                    "descrizione" | transloco
                    }}</b>
                </p>
              </label>
            </div>
            <stdout-text-input class="bordo" id="2" placeholder="Inserisci descrizione" [(ngModel)]="descriptionEdit"
              type="text"></stdout-text-input>
          </div>
        </div>
        <div class="md:mt-1 mt-[10px] ml-0 md:ml-[25px]">
          <div class="mb-[10px]">
            <label class="terzalabel" for="1"><b style="color: #0b0e42">{{ "link" | transloco }}</b></label>
          </div>
          <stdout-text-input class="bordo" id="3" placeholder="Inserisci Link" [(ngModel)]="linkEdit"
            type="text"></stdout-text-input>
        </div>
        <!-- <div class="md:mr-[25px] mr-0 md:mt-1 mt-[10px] col-span-2 md:w-auto">
          <div class="rounded-md w-full">
            <div class="mb-[10px] mt-1">
              <label class="primalabel" for="1"><b style="color: #0b0e42">Programma</b></label>
            </div>
            <stdout-text-input class="bordo" id="1" placeholder="Inserisci per programmare" type="datetime-local"
              [(ngModel)]="customDate"></stdout-text-input>
          </div>
        </div> -->
      </div>

      <div class="flex flex-wrap md:flex-row flex-col">
        <div class="mt-[30px] opacity-50 pointer-events-none">
          <div class="flex flex-wrap not">
            <label>
              <p [ngClass]="{'testo-errore': notificaErr }">{{ "dest_not" | transloco }}</p>
            </label>
          </div>
        </div>
        <div class="mt-[25px] ml-[25px] opacity-50 pointer-events-none">
          <div class="flex flex-wrap fix-check-not items-center">
            <stdout-checkbox id="check1" (change)="updateDestination(1, $event,true)" class="mr-2  cursor-pointer"
              #checkbox1Edit></stdout-checkbox>

            <label>
              <p>{{ "tutti" | transloco }}</p>
            </label>
          </div>
        </div>
        <div class="mt-[25px] ml-[25px] opacity-50 pointer-events-none">
          <div class="flex flex-wrap fix-check-not items-center">
            <stdout-checkbox id="check2" (change)="updateDestination(2, $event,true)" class="mr-2  cursor-pointer"
              #checkbox2Edit></stdout-checkbox>
            <label>
              <p>{{ "solo_mil" | transloco }}</p>
            </label>
          </div>
        </div>
        <div class="mt-[25px] ml-[25px] opacity-50 pointer-events-none">
          <div class="flex flex-wrap fix-check-not items-center">
            <stdout-checkbox id="check3" (change)="updateDestination(3, $event,true)" class="mr-2  cursor-pointer"
              #checkbox3Edit></stdout-checkbox>
            <label>
              <p>{{ "solo_pub" | transloco }}</p>
            </label>
          </div>
        </div>
        <div class="w-[100%]" style="text-align: -webkit-right">
          <div class="bg-white rounded-xl">
            <div class="flex p-4 gap-4">
              <div class="w-1/3">
                <stdout-button class="btn-blu w-full" size="large" color="white" (click)="showModalEdit = false">
                  <h2>{{ "chiudi" | transloco }}</h2>
                </stdout-button>
              </div>
              <div class="w-1/3">
                <stdout-button class="btn-blu w-full" size="large" color="white" (click)="modalDelete = true">
                  <h2>{{ "elimina" | transloco }}</h2>
                </stdout-button>
              </div>
              <div class="w-1/3">
                <stdout-button class="btn-blu w-full" size="large" color="white" (click)="editNotification()"
                  type="submit">
                  <h2>{{ "salva" | transloco }}</h2>
                </stdout-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </stdout-card-content>
  </stdout-card>

</div>






<div
  class="absolute z-[5000] left-0 top-0 flex place-content-center items-center bg-black bg-opacity-25 w-screen h-screen"
  *ngIf="modalDelete" (click)="$event.stopPropagation()">
  <app-modale title="Conferma eliminazione"
    content="Sei sicuro di volere eliminare definitivamente gli elementi selezionati?" [width]="504">
    <div class="flex justify-center items-center mt-10">
      <div class="w-full mr-[5px]  cursor-pointer">
        <stdout-button class="btn-bianco" (click)="modalDelete = false" size="large" color="white">
          <h2>{{ "annulla" | transloco }}</h2>
        </stdout-button>
      </div>
      <div class="w-full ml-[5px]  cursor-pointer">
        <stdout-button class="btn-blu" (click)="deleteNotification()" size="large" color="white">
          <h2>{{ "elimina_selezionati" | transloco }}</h2>
        </stdout-button>
      </div>
    </div>
  </app-modale>
</div>